import { connect } from 'react-redux'
import ClientDetail from '../components/ClientDetail'
import * as api from '../store/api'

const mapStateToProps = (state) => {
    return {
        clients: state.service.clients,
        events: state.service.events,
        user: state.service.user
    };
}

const mapDispatchToProps = (dispatch) => ({
    checkUserSession: (callback) => { dispatch(api.checkUserSession()).then(callback) },
    fetchClients: (callback) => {
        dispatch(api.fetchClients()).then(callback)
    },
    fetchEvents: (clientId, callback) => {
        dispatch(api.fetchPastEvents(clientId)).then(callback)
    },
    createNextEvent: (data, callback) => {
        dispatch(api.createNextEvent(data)).then(callback)
    },
    createClient: (data, callback) => {
        dispatch(api.createClient(data)).then(callback)
    },
    updateClient: (data, callback) => {
        dispatch(api.updateClient(data)).then(callback)
    },
    listAssets: (assetType, callback) => {
        dispatch(api.listAssets(assetType)).then(callback)
    },
    uploadAsset: (data, callback) => {
        dispatch(api.uploadAsset(data)).then(callback)
    },
    generatePDF: (data, callback) => {
        dispatch(api.generatePDF(data)).then(callback)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetail)
